"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLuxonDateFormatStringWithoutTime = exports.isDateWeekend = void 0;
const isDateWeekend = (date) => {
    const dayOfWeek = date.getDay();
    // 6 = Saturday and 0 = Sunday
    return dayOfWeek === 6 || dayOfWeek === 0;
};
exports.isDateWeekend = isDateWeekend;
// lifted from luxon package
const _parseFormat = (fmt) => {
    // white-space is always considered a literal in user-provided formats
    // the " " token has a special meaning (see unitForToken)
    let current = null;
    let currentFull = '';
    let bracketed = false;
    const splits = [];
    // eslint-disable-next-line no-restricted-syntax, no-plusplus
    for (let index = 0; index < fmt.length; index++) {
        const char = fmt.charAt(index);
        if (char === "'") {
            if (currentFull.length > 0) {
                splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull,
                });
            }
            current = null;
            currentFull = '';
            bracketed = !bracketed;
        }
        else if (bracketed) {
            currentFull += char;
        }
        else if (char === current) {
            currentFull += char;
        }
        else {
            if (currentFull.length > 0) {
                splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
            }
            currentFull = char;
            current = char;
        }
    }
    if (currentFull.length > 0) {
        splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull,
        });
    }
    return splits;
};
/**
 * The list of tokens that are used to format an aspect of time.
 * Often luxon will have many variants using the same character multiple times to create different formats.
 */
const _LUXON_TIME_FORMAT_TOKENS_SINGLE_UNIT = [
    'S',
    'u',
    's',
    'm',
    'h',
    'H',
    'Z',
    'z',
    'a',
    't',
    'T',
    'f',
    'F', // localized datetime with zone
];
const _isTimeToken = (token) => {
    if (token.literal) {
        return false;
    }
    return _LUXON_TIME_FORMAT_TOKENS_SINGLE_UNIT.some((timeToken) => token.val.includes(timeToken));
};
const validateLuxonDateFormatStringWithoutTime = (format) => {
    const tokens = _parseFormat(format);
    const unsupportedTokensPresent = [];
    tokens.forEach((token) => {
        if (_isTimeToken(token)) {
            unsupportedTokensPresent.push(`${token.val}`);
        }
    });
    return {
        isValid: unsupportedTokensPresent.length === 0,
        error: unsupportedTokensPresent.length > 0
            ? `Encountered invalid date format [${format}] with unsupported time tokens [${unsupportedTokensPresent.join(', ')}]`
            : undefined,
    };
};
exports.validateLuxonDateFormatStringWithoutTime = validateLuxonDateFormatStringWithoutTime;
//# sourceMappingURL=date.utils.js.map